import card1 from "../assets/airfry.jpg";
import card2 from "../assets/convection.jpg";
import card3 from "../assets/micro.jpg";
import card4 from "../assets/mixer.jpg";

import card5 from "../assets/film1.png";
import card6 from "../assets/film2.png";
import card7 from "../assets/film3.png";
import card8 from "../assets/film4.png";
import card9 from "../assets/storage1.png";
import card10 from "../assets/storage2.png";
import card11 from "../assets/storage3.png";
import card12 from "../assets/storage4.png";

const cookingItems = [
  {
    name: "airfryer",
    image: card1,
    link: "https://www.amazon.in/dp/B09VDPYKSC/ref=cm_sw_r_as_gl_api_gl_i_1JQVCY84BMYDZJF56J2A?linkCode=ml2&tag=youtube04d77-21",
  },
  {
    name: "convection oven",
    image: card2,
    link: "https://www.amazon.in/dp/B07MHDZ4W3/ref=cm_sw_r_as_gl_api_gl_i_WJ6HQX2D1VYTNP65CM6M?linkCode=ml1&tag=youtube04d77-21",
  },
  {
    name: "microwave",
    image: card3,
    link: "https://www.amazon.in/dp/B07M8GJKH2/ref=cm_sw_r_as_gl_api_gl_i_VR9E32QTGN2WSHN9EN99?linkCode=ml1&tag=youtube04d77-21",
  },
  {
    name: "mixer grinder",
    image: card4,
    link: "https://www.amazon.in/dp/B010LE4R94/ref=cm_sw_r_as_gl_api_gl_i_ZAX6A54K1T5P18NK02PK?linkCode=ml1&tag=youtube04d77-21&th=1",
  },
];

const tags = [
  "Kitchen Appliances",
  "pan",
  "Pans",
  "cutting board",
  "blender",
  "sandwich maker",
  "appliances",
  "frying pan",
  "toaster",
  "whisk",
];

// const cookingItems = [
//   { img: "https://source.unsplash.com/400x400/?kitchen-scale" },
//   { img: "https://source.unsplash.com/400x400/?measuring-cups" },
//   { img: "https://source.unsplash.com/400x400/?bench-scraper" },
//   { img: "https://source.unsplash.com/400x400/?whisk" },
// ];

const storageItems = [
  {
    name: "Glass Jars Set",
    image: card9,
    link: "https://www.amazon.in/dp/B099WPXSRN/ref=cm_sw_r_as_gl_api_gl_i_S33W2NN6VRBJGYVAB2SA?linkCode=ml1&tag=youtube04d77-21",
  },
  {
    name: "Spice Box",
    image: card10,
    link: "https://www.amazon.in/dp/B0BXSFC1M7/ref=cm_sw_r_as_gl_api_gl_i_C24QDTZSQKTBQESFB63W?linkCode=ml1&tag=youtube04d77-21",
  },
  {
    name: "Oil Dispenser",
    image: card11,
    link: "https://www.amazon.in/dp/B0BF79DTDG/ref=cm_sw_r_as_gl_api_gl_i_PXBE2VEX8ANK1GTEAKGK?linkCode=ml1&tag=youtube04d77-21",
  },
  {
    name: "Storage Jars",
    image: card12,
    link: "https://www.amazon.in/dp/B09CTY76KR/ref=cm_sw_r_as_gl_api_gl_i_dl_BKGB0SGKCW2CTJXYT4PC?linkCode=ml1&tag=youtube04d77-21&th=1",
  },
];


const filmingItems = [
  {
    name: "Vlogging Camera",
    image: card5,
    link: "https://www.amazon.in/dp/B08D45C1YF/ref=cm_sw_r_as_gl_api_gl_i_YCDKG94KDV8WTHF8QMZ2?linkCode=ml1&tag=youtube04d77-21&th=1",
  },
  {
    name: "Tripod Stand",
    image: card6,
    link: "https://www.amazon.in/dp/B075JCR1PJ/ref=cm_sw_r_as_gl_api_gl_i_J4Z9CCZ3EWXWB0HB53JP?linkCode=ml2&tag=youtube04d77-21&th=1",
  },
  {
    name: "Camera Stand",
    image: card7,
    link: "https://www.amazon.in/dp/B074CWD7MS/ref=cm_sw_r_as_gl_api_gl_i_JNKH9FA8JXGZW745ZYYK?linkCode=ml1&tag=youtube04d77-21&th=1",
  },
  {
    name: "Gorilla tripod",
    image: card8,
    link: "https://www.amazon.in/dp/B0BRZF329M/ref=cm_sw_r_as_gl_api_gl_i_dl_RJ7614R4BQYWJFG80D6P?linkCode=ml1&tag=youtube04d77-21",
  },
];


const TagRow = () => (
  <div className="flex flex-wrap gap-3 justify-center mb-10">
    <span className="px-4 py-1 rounded-full bg-white border text-sm">
      Discover more
    </span>
    {tags.map((tag, i) => (
      <span
        key={i}
        className="px-4 py-1 rounded-full border text-blue-600 text-sm"
      >
        ⊕ {tag}
      </span>
    ))}
  </div>
);

const ProductGrid = ({ items }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
    {items.map((item, index) => (
      <div
        key={index}
        className="bg-white rounded-2xl p-6 border-4 border-[#8a8a00] flex flex-col items-center text-center"
      >
        {/* Image */}
        <div className="h-48 flex items-center justify-center mb-6">
          <img
            src={item.image || item.img}
            alt={item.name || "product"}
            className="max-h-full object-contain"
          />
        </div>

        {/* Name (only if exists) */}
        {item.name && (
          <h3 className="text-lg font-serif capitalize text-gray-800 mb-4">
            {item.name}
          </h3>
        )}

        {/* Button (only if link exists) */}
        {item.link && (
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-auto bg-[#e6c04c] text-[#5a5a00] px-6 py-2 rounded-full text-sm font-medium hover:bg-[#d8b43f] transition"
          >
            View Product
          </a>
        )}
      </div>
    ))}
  </div>
);


const Shop = () => {
  return (
    <section className="bg-[#fff9e6]">
      
      {/* ================= COOKING & BAKING ================= */}
      <div className="py-24 max-w-7xl mx-auto px-6">
        <TagRow />

        <h2 className="text-center text-5xl font-serif text-[#c17b8c] mb-16">
          Cooking & Baking Essentials
        </h2>

        <ProductGrid items={cookingItems} />
      </div>

      {/* ================= STORAGE ================= */}
      <div className="py-24 bg-[#b87078]">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-5xl font-serif text-yellow-300 mb-10">
            Storage
          </h2>

          <TagRow />
          <ProductGrid items={storageItems} />
        </div>
      </div>

      {/* ================= FILMING EQUIPMENT ================= */}
      <div className="py-24 max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-5xl font-serif text-[#8b6c8d] mb-6">
          Filming Equipment
        </h2>

        <p className="text-[#b84b6d] max-w-2xl mx-auto mb-10">
          Everything I use to film and shoot my content – all the photos and
          videos you see on the blog and my socials!
        </p>

        <span className="inline-block mb-12 px-6 py-2 rounded-full bg-blue-600 text-white text-sm">
          ⊕ Kitchen supplies
        </span>

        <ProductGrid items={filmingItems} />
      </div>

    </section>
  );
};

export default Shop;
